import ApolloClient from "apollo-boost";
import { message } from "antd";
import history from "./history";

// session 過期/未登入時後端 GraphQL 會回 401。集中在這裡處理：
// 跳一次提示並 SPA 導向登入頁。防重入旗標避免多個查詢同時 401 時洗版/重複導向。
let handlingUnauthenticated = false;

function handleUnauthenticated() {
  if (handlingUnauthenticated) {
    return;
  }
  handlingUnauthenticated = true;

  message.warning("登入已過期，請重新登入");
  if (history.location.pathname !== "/login") {
    history.push("/login");
  }

  setTimeout(() => {
    handlingUnauthenticated = false;
  }, 3000);
}

export default new ApolloClient({
  uri: "/graphql",
  onError: ({ networkError }) => {
    if (networkError && networkError.statusCode === 401) {
      handleUnauthenticated();
    }
  },
});
